import {useCallback, useState} from 'react';
import {toast} from 'sonner';
import {
  CreateGuestByParticipantPayload,
  CreateGuestByParticipantResponse,
} from '@chekin/api';
import {postMultipleItems} from 'pages/Auth/utils';
import {useCreateGuestByParticipant} from 'hooks/useCreateGuestByParticipant';
import {FailedMultipleSaveResponse} from 'pages/Auth/types';
import {FastAPIServiceError} from '@chekin/core';

type Props = {
  onSuccess?: (data: CreateGuestByParticipantResponse[]) => void;
  onError?: (
    results: FailedMultipleSaveResponse<
      Omit<CreateGuestByParticipantPayload, 'reservation_id'>,
      FastAPIServiceError
    >[],
  ) => void;
};
function useMutateMultipleGuests({onSuccess, onError}: Props) {
  const {mutateAsync} = useCreateGuestByParticipant();
  const [isMutating, setIsMutating] = useState(false);

  const mutateAsyncMultiple = useCallback(
    async (payload: Omit<CreateGuestByParticipantPayload, 'reservation_id'>[]) => {
      setIsMutating(true);
      try {
        const {failed, success} = await postMultipleItems<
          Omit<CreateGuestByParticipantPayload, 'reservation_id'>,
          FastAPIServiceError,
          CreateGuestByParticipantResponse
        >(payload, mutateAsync);

        if (failed.length > 0) {
          onError?.(failed);
        }

        if (failed.length === 0) {
          onSuccess?.(success);
        }
      } catch (error) {
        toast.error('Something went wrong');
        console.error(error);
      } finally {
        setIsMutating(false);
      }
    },
    [mutateAsync, onSuccess, onError],
  );

  return {mutateAsyncMultiple, isMutating};
}

export {useMutateMultipleGuests};
